/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import {render} from 'preact';
import App from './App';
import packageJson from '../../../package.json' with {type: 'json'};
import config from '../config';

// Log app and version
console.log(packageJson.name, packageJson.version);

render(<App config={config} />, document.getElementById('app'));